import { render, staticRenderFns } from "./ChannelNewModal.vue?vue&type=template&id=5cbf5682&"
import script from "./ChannelNewModal.vue?vue&type=script&lang=js&"
export * from "./ChannelNewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports